import React, { useEffect } from "react";
import InfoScreenTemplate from "@tvg/atomic-ui/_templates/InfoScreen";
import { useNavigate } from "@tvg/custom-hooks";
import { useDispatch, useSelector } from "react-redux";
import { get } from "lodash";
import parseCAPIMessage from "@tvg/utils/capiUtils";
import tvgConf from "@tvg/conf";

import {
  getBodyContent,
  getRedirectBrand,
  onClickClose,
  onClickSecondary,
  onClickSuccess,
  replaceBrandBy,
  replaceStateNameBy
} from "../utils/handlers";
import { setGtmInfoScreenErrorEvent } from "../utils/gtm/infoErrors";
import useOnfidoChecks from "../hooks/useOnfidoChecks";
import { getSelectedPromo } from "../utils/selectors";
import useNativeCameraAccess from "../hooks/useNativeCameraAccess";

export const InfoScreenComp = ({ device = "mobile" }) => {
  const history = useNavigate();

  const dispatch = useDispatch();
  const showOnfidoFailureWithChat = useSelector((store) =>
    get(store, "capi.featureToggles.showOnfidoFailureWithChat", false)
  );
  const infoScreen = useSelector((store) =>
    get(store, "registration.infoScreen", {})
  );
  const currentStep = useSelector((store) =>
    get(store, "registration.currentStep", "")
  );
  const infoScreenCapi = useSelector((store) =>
    get(
      parseCAPIMessage(store, "capi.messages.registrationTexts"),
      "infoScreen"
    )
  );
  const hasValidatedOnfido = useSelector((store) =>
    get(store, "registration.onfido.hasValidatedOnfido", false)
  );
  const accountId = useSelector((store) =>
    get(store, "registration.onfido.accountId", "")
  );
  const applicantId = useSelector((store) =>
    get(store, "registration.onfido.applicantId", "")
  );
  const uuid = useSelector((store) =>
    get(store, "registration.onfido.uuid", "")
  );
  const welcomeFields = useSelector((store) =>
    get(store, "registration.welcome.fields", false)
  );
  const addressFields = useSelector((store) =>
    get(store, "registration.address.fields", false)
  );
  const selectedPromo = useSelector((store) => getSelectedPromo(store));
  const { redirectUrl, state, status } = infoScreen;
  const statusLabel = get(infoScreenCapi, [status]);
  const bodyContentField = get(statusLabel, "bodyContent", []);
  const bodyContent = state
    ? getBodyContent({ infoScreen, bodyContentField })
    : bodyContentField;
  const buttonTextSecondary = replaceStateNameBy(state)(
    get(statusLabel, "buttonTextSecondary", "")
  );
  const buttonTextSuccess = replaceBrandBy(getRedirectBrand({ redirectUrl }))(
    get(statusLabel, "buttonTextSuccess", "")
  );
  const gtmInfoStatus = status !== "" ? status : "failCreateAccount";
  const buttonTextClose = get(
    infoScreenCapi[gtmInfoStatus],
    "buttonTextClose",
    ""
  );

  // Check iOS RN camera access for Onfido flow
  useNativeCameraAccess(status, dispatch);

  const gtmData = {
    eventAction: get(infoScreenCapi[gtmInfoStatus], "gtmEventAction", ""),
    module: `${currentStep[0] + currentStep.slice(1).toLowerCase()} Information`
  };

  useEffect(() => {
    setGtmInfoScreenErrorEvent({
      ...gtmData,
      eventLabel: get(bodyContent[0], "title", "")
    });
  }, []);

  const isOnfidoChecksStatus = status === "onfidoChecks";

  const [showDelayedText] = useOnfidoChecks({
    dispatch,
    showOnfidoFailureWithChat,
    isOnfidoChecksStatus,
    hasValidatedOnfido,
    accountId,
    onfidoApplicantId: applicantId,
    verificationUuid: uuid,
    welcomeFields,
    addressFields,
    selectedPromo
  });

  return (
    <InfoScreenTemplate
      {...{
        ...statusLabel,
        buttonTextSuccess,
        buttonTextSecondary,
        icon: status,
        bodyContent,
        isOnfidoChecks: isOnfidoChecksStatus,
        showDelayedText
      }}
      onClickSuccess={onClickSuccess({
        dispatch,
        currentStep,
        status,
        redirectUrl,
        watchTVGUrl: get(statusLabel, "watchTVGUrl", ""),
        gtmData: { ...gtmData, eventLabel: buttonTextSuccess },
        welcomeFields
      })}
      onClickSecondary={onClickSecondary({
        status,
        dispatch,
        push: history.push,
        gtmData: { ...gtmData, eventLabel: buttonTextSecondary }
      })}
      onClickClose={onClickClose({
        status,
        push: history.push,
        gtmData: { ...gtmData, eventLabel: buttonTextClose }
      })}
      device={device}
      brand={tvgConf().brand}
    />
  );
};

export default InfoScreenComp;
